import { useForm } from "react-hook-form";
import { ArbitrageAbi, contractAddresses } from "../../../../meta";
import {
  useNotificationContext,
  useWingsContractWrite,
  Typography,
  Card,
  MyFormProvider,
  FlexCol,
  Button,
} from "../../../../shared";
import { parseUnits } from "viem";
import { DisplayMaxMintBurnPriceDiff } from "./DisplayMaxMintBurnPriceDiff";

export const SetMaxMintBurnPriceDiff: React.FC = () => {
  const { showNotification } = useNotificationContext();
  const methods = useForm();
  const { reset, handleSubmit } = methods;

  const { writeContractAsync: setMaxMintBurnPriceDiff, isPending: isSetting } =
    useWingsContractWrite();

  const onSubmit = async (data: any) => {
    await setMaxMintBurnPriceDiff(
      {
        abi: ArbitrageAbi,
        address: contractAddresses.Arbitrage,
        functionName: "setMaxMintBurnPriceDiff",
        args: [parseUnits(data.priceTolerance, 8)],
      },
      {
        onSuccess: () => {
          reset();
          showNotification({
            status: "success",
            content: <Typography>success</Typography>,
          });
        },
      }
    );
  };

  return (
    <Card className="w-2/3" hasBorder>
      <MyFormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <FlexCol className="w-full p-4 gap-4">
          <DisplayMaxMintBurnPriceDiff />
          <Typography>Arbitrage / SetMaxMintBurnPriceDiff /</Typography>
          <FlexCol className="gap-3">
            <input
              {...methods.register("priceTolerance")}
              placeholder="on 8 decimals"
              type="text"
              step="0.01"
              className="input input-bordered w-full"
            />
            <Button type="submit" loading={isSetting}>
              Update Arbitrager
            </Button>
          </FlexCol>
        </FlexCol>
      </MyFormProvider>
    </Card>
  );
};
